module.exports = __webpack_public_path__ + "img/yaguangmofakoudaiWu.min.19f771d9.png";